import type { ModuleSetupContext } from '@/shared/registry/types';

import { webformsKeys } from './api';

/** `webforms.submission-updated` / `webforms.form-updated` on the topic `webform:<formId>` (no personal data). */
interface WebformPayload {
  formId: string;
  submissionId?: string | null;
  reason?: string;
}

/**
 * Realtime of web forms (docs/modules/webforms.md): an open form (builder, submissions, statistics) subscribes its topic
 * `webform:<id>`; a new submission, the CRM's answer, a retry or a deletion refresh the lists, the card and the counters;
 * a change of the form refreshes it. (After a reconnect the shell refetches whatever is on screen.)
 */
export function setupWebformsRealtime({ queryClient, realtime }: ModuleSetupContext): void {
  realtime.on<WebformPayload>('webforms.submission-updated', (payload) => {
    if (!payload.formId) return;
    void queryClient.invalidateQueries({ queryKey: webformsKeys.submissions(payload.formId) });
    void queryClient.invalidateQueries({ queryKey: ['webforms', 'stats', payload.formId] });
    void queryClient.invalidateQueries({ queryKey: ['webforms', 'forms'] });
    void queryClient.invalidateQueries({ queryKey: webformsKeys.form(payload.formId) });
    if (payload.submissionId) void queryClient.invalidateQueries({ queryKey: webformsKeys.submission(payload.submissionId) });
  });
  realtime.on<WebformPayload>('webforms.form-updated', (payload) => {
    if (!payload.formId) return;
    void queryClient.invalidateQueries({ queryKey: webformsKeys.form(payload.formId) });
    void queryClient.invalidateQueries({ queryKey: ['webforms', 'forms'] });
  });
}
